<template>
  <nav class="navbar navbar-default" id="navbar" v-bind:class="{ active: isTopNavbarActive }">
    <div class="container-fluid">
      <div class="navbar-collapse collapse in">
        <ul class="nav navbar-nav navbar-mobile">
          <li>
            <button type="button" class="sidebar-toggle" @click="toggleSidebarNav()">
              <i class="fa fa-bars"></i>
            </button>
          </li>
          <li  class="logo">
            <a class="navbar-brand" href="#"><span class="highlight"><strong>Law Fluent Identity</strong></span></a>
          </li>
          <li>
            <button type="button" class="navbar-toggle" @click="toggleTopNavBar()">
              <i class="fa fa-user fa-lg"></i>
            </button>
          </li>
        </ul>
        <ul class="nav navbar-nav navbar-left">
          <li class="navbar-title">Law Fluent Identity</li>
        </ul>

        <ul class="nav navbar-nav navbar-right">
          <li class="dropdown profile">
            <a>
              <i class="fa fa-user fa-lg icon-primary"></i>
            </a>
            <div class="dropdown-menu">
              <div class="profile-info">
                <h4 class="username">
                  <span>{{userProfileEmail}}</span>
                </h4>

              </div>
              <ul class="action">
                <li>
                  <a :href="logoutUrl" role="button">Log out</a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import ConfigService from '@/services/ConfigService'
import NavMixin from './NavMixin'
import { mapGetters } from 'vuex'

export default {
  data: function () {
    return {
      logoutUrl: ConfigService.logoutUrl()
    }
  },
  computed: {
    ...mapGetters([
      'userProfileEmail'
    ])
  },
  mixins: [NavMixin]
}
</script>
